import * as React from 'react';
import { PropsWithChildren } from 'react';
import classNames from 'classnames';

import style from './OptionsList.module.css';

export const OptionsList = ({
  children,
  component: Component = 'ul',
  className,
}: PropsWithChildren<{
  component?: React.ElementType;
  className?: string;
}>) => {
  return (
    <Component className={classNames(style.options, className /*ThemeDefinition.listSelector.options*/)}>
      {children}
    </Component>
  );
};
